import {config, getCookie} from '../helpers';

const allowedApiUrl = (url) =>
    url.protocol === 'https:' ||
    (url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname));

function parseActiveAdminApiUrl() {
    try {
        const raw = getCookie('api_url') || config('api.url');
        if (!raw) {
            return null;
        }
        const api = new URL(raw);
        if (!allowedApiUrl(api) || api.username || api.password || api.search || api.hash) {
            return null;
        }
        return api;
    } catch (_) {
        return null;
    }
}

export function customerFeatureEnabled() {
    return parseActiveAdminApiUrl() !== null;
}

export function customerConfig() {
    const api = parseActiveAdminApiUrl();
    if (!api) {
        return null;
    }
    return {
        origin: 'https://v2.fitlap.ee',
        apiBaseUrl: api.href.replace(/\/$/, ''),
    };
}
